import Loadable from 'pages/LumenisXVersions/Loadable';
import reducer from './modules/lumenisXVersions.slice';

export default {
	component: Loadable,
	reducer
};